module.exports = __webpack_public_path__ + "img/DROP-8-820x1024.816d1069.png";